/* eslint-disable */
export default {
  sureToDeleteVoiceMail:
    'Tem a certeza de que pretende eliminar este correio de voz?',
  sureToDeleteFax: 'Tem a certeza de que pretende eliminar este fax?',
  doNotAskAgain: 'Não perguntar novamente',
} as const;

// @key: @#@"sureToDeleteVoiceMail"@#@ @source: @#@"Are you sure you want to delete this voicemail?"@#@
// @key: @#@"sureToDeleteFax"@#@ @source: @#@"Are you sure you want to delete this fax?"@#@
// @key: @#@"doNotAskAgain"@#@ @source: @#@"Don't ask me again"@#@
